module.exports = __webpack_public_path__ + "static/media/addvalues1.8771d6ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Tutorial/screenshots/Managing/addvalues1.jpg
// module id = 1634
// module chunks = 0